"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenu = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _navigation = require("../../context/navigation");
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _models = require("../../models");
var _Join = require("../Join");
var _BurgerMenuContent = require("./BurgerMenuContent");
var _BurgerMenuTab = require("./BurgerMenuTab");
var _LazyLinks = require("./Links/LazyLinks");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const BurgerMenu = ({
  mobilePersonalMenuOutlet
}) => {
  const {
    BurgerMenu: BurgerMenuType,
    AccountSideMenu: AccountSideMenuType
  } = ToggleMenuFlyout.MenuTypes;
  const {
    activeMenu,
    toggleActiveMenu
  } = (0, _navigation.useActiveMenu)();
  const isMobile = (0, _hooks.useIsMobile)();
  const handleTabClick = (0, _react.useCallback)(tabName => {
    const menuType = tabName === _models.BurgerMenuTabNames.ProductsTab ? BurgerMenuType : AccountSideMenuType;
    toggleActiveMenu(menuType);
  }, [AccountSideMenuType, BurgerMenuType, toggleActiveMenu]);
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const customerInitials = (0, _hooks.useCustomerInitials)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const isLoggedIn = !isAnonymousUser;
  const isMenuActive = activeMenu === BurgerMenuType || isMobile && activeMenu === AccountSideMenuType;
  const activeTab = activeMenu === BurgerMenuType ? _models.BurgerMenuTabNames.ProductsTab : _models.BurgerMenuTabNames.AccountTab;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isTopAreaNavigationVisible = (0, _hooks.useIsTopAreaNavigationVisible)();
  const onClickOverlay = (0, _react.useCallback)(() => {
    toggleActiveMenu(BurgerMenuType);
  }, [BurgerMenuType, toggleActiveMenu]);
  const slots = (0, _react.useMemo)(() => ({
    backdrop: _mui.Backdrop
  }), []);
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ModalRoot, {
      slots: slots,
      open: isMenuActive,
      onClose: onClickOverlay,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Slide, {
        in: isMenuActive,
        direction: "right",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuRoot, {
          isMobile: true,
          isTopAreaNavigationVisible: isTopAreaNavigationVisible,
          "data-testid": getTestId(_constants.BURGER_MENU_ROOT),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuContainer, {
            "data-testid": getTestId(_constants.BURGER_MENU_CONTAINER),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuTab.BurgerMenuTab, {
              fullWidth: !isLoggedIn,
              activeTab: activeTab,
              tabName: _models.BurgerMenuTabNames.ProductsTab,
              tabPrefix: _icons.BurgerMenu,
              onTabClick: handleTabClick,
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuWithJoinIconContainer, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Label, {
                  variant: "overline",
                  fontWeight: "bold",
                  children: translations.menu
                }), isAnonymousUser ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Join.JoinIcon, {
                  variant: "smallButton"
                }) : null]
              })
            }), isLoggedIn ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuTab.BurgerMenuTab, {
              activeTab: activeTab,
              tabName: _models.BurgerMenuTabNames.AccountTab,
              tabPrefix: customerInitials ?? '',
              isLoggedIn: isLoggedIn,
              onTabClick: handleTabClick,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Label, {
                variant: "overline",
                fontWeight: "bold",
                children: translations.myAccount
              })
            }) : null]
          }), activeTab === _models.BurgerMenuTabNames.ProductsTab && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyLinks.LazyLinks, {}), activeTab === _models.BurgerMenuTabNames.AccountTab && !isAnonymousUser ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PersonalMenuNav, {
            "aria-label": translations.myAccount,
            children: mobilePersonalMenuOutlet
          }) : null]
        })
      })
    });
  }
  if (!isMenuActive) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuRoot, {
    isDesktop: true,
    isTopAreaNavigationVisible: isTopAreaNavigationVisible,
    as: "div",
    "data-testid": getTestId(_constants.BURGER_MENU_ROOT),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuInner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyLinks.LazyLinks, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuContent.LazyBurgerMenuContent, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuBackdrop, {
        open: true,
        "data-testid": getTestId(_constants.BURGER_MENU_BACKDROP),
        onClick: onClickOverlay
      })]
    })
  });
};
exports.BurgerMenu = BurgerMenu;